import React from 'react';
import { Box, Container, Heading, Text, Button, VStack } from '@chakra-ui/react';

const ErrorFallback = () => {
  const reload = () => window.location.assign('/');

  return (
    <Box position="relative" minH="100vh" overflow="hidden">
      <Container maxW="720px" py={{ base: 10, md: 16 }}>
        <VStack spacing={6} align="stretch" data-testid="error-fallback">
          <Heading as="h1" size="xl">Something went wrong.</Heading>
          <Text fontSize="lg">
            An unexpected error broke this page. The issue has been reported. Try reloading to get back to the converter.
          </Text>
          <Button onClick={reload} colorScheme="orange" size="lg" alignSelf="flex-start">
            Reload
          </Button>
        </VStack>
      </Container>
    </Box>
  );
};

export default ErrorFallback;
